import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/pet/og.png';
import type { BasePageConfig } from '../../../BasePageConfig';

export type Config = BasePageConfig;
export const config: Config = {
  seo: {
    title: 'Cat Insurance • Tailored Pet Insurance for Cats by Lemonade',
    metaTitle: 'Cat Insurance • Tailored Pet Insurance for Cats by Lemonade',
    description: 'Pet Insurance Tailored for Your Cat Protection perfectly curated for your cat (and your pocket)',
    ogImage: ogImage.src,
    uniqueCanonicalUrl: 'https://www.lemonade.com/pet/cats',
  },
  layout: { ...sharedConfig['en-US'].layout },
};
